<template>
    <div id="container">
        <div class="page_top">
				<div class="top_left">
					<div class="logo">
						<el-image style="width: 35px; height: 35px" :src="require('../assets/logo.png')" />
					</div>
					<h2 class="wms_name">运力智能驾驶仓</h2>
				</div>
				<div class="top_time">
                     <el-date-picker v-model="seachData" type="daterange" align="right" unlink-panels range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"> </el-date-picker>
                    <el-button style="margin-left: 10px;" size="medium" @click="getData">搜索</el-button>
				</div>
		</div>
        <div class="order_list">
            <div class="order">
                <div class="order_name">总任务数</div>
                <h2 class="order_num">{{ listOrders.totalNumber }}</h2>
            </div>
            <div class="order">
                <div class="order_name">出口</div>
                <h2 class="order_num">{{ listOrders.exportNumber }}</h2>
            </div>
            <div class="order">
                <div class="order_name">进口</div>
                <h2 class="order_num">{{ listOrders.importNumber }}</h2>
            </div>
            <div class="order">
                <div class="order_name">配货</div>
                <h2 class="order_num">{{ listOrders.distributionNumber }}</h2>
            </div>
            <div class="order">
                <div class="order_name">调拨</div>
                <h2 class="order_num">{{ listOrders.allocateNumber }}</h2>
            </div>
        </div>
        <div class="main">
            <div class="main_left">
                <div class="home_today" >
                    <div class="home_tit">
                        运力折线图
                    </div>
                    <div id="capacityLine" style="width: 100%;height: 100%;"></div>
                </div>
                <div class="ship_order" id="ship_order"></div>
                <!--货主订单执行情况-->
            </div>
				<div class="main_midd">
                    <div class="imple"></div>
                    <div class="imple"></div>

				</div>
				<div class="main_rig">
					 <div class="situ_tit">
					 	上一小时作业情况
					 </div>

				</div>
			</div>
    </div>
</template>
<script>
    export default {
        name: 'screen',
        data() {
            return {
                seachData: '',
                // 单量
                listOrders:{},
                pickerOptions: {
                    shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                }
            }
        },
        async mounted() {
            // 设置默认时间为近一个月        
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            this.seachData = [this.getFormattedDateTime(start), this.getFormattedDateTime(end)];
            this.search();                                                                                                                         
        },
        methods: {

            getFormattedDateTime(data) { 
                const year = data.getFullYear();
                const month = (data.getMonth() + 1).toString().padStart(2, '0');
                const day = data.getDate().toString().padStart(2, '0');
                return `${year}-${month}-${day}`;
            },
            getData(){
                if(this.seachData === null){
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                    this.seachData = [this.getFormattedDateTime(start), this.getFormattedDateTime(end)];
                }else{
                    this.seachData = [this.getFormattedDateTime(this.seachData[0]), this.getFormattedDateTime(this.seachData[1])];
                }
                this.search()
            },
            search(){
                // 获取期间单量数据
                this.getBillNums()
                // 获取期间单量折线图数据
                this.getBillNumsLineReport()
            },
            // 获取期间单量数据
            getBillNums(){
                this.$api.getBillNums( this.seachData[0], this.seachData[1] ).then(res =>{
                    this.listOrders = res;
                })
            },
            // 获取期间单量折线图数据
            getBillNumsLineReport(){
                this.$api.getBillNumsLineReport( this.seachData[0], this.seachData[1] ).then(res =>{
                    var capacityLine =this.$echarts.init(document.getElementById('capacityLine'));
                    var option = {
                        tooltip: {
                            trigger: 'axis',
                            axisPointer: {
                                type: 'cross',
                                label: {
                                backgroundColor: '#6a7985'
                                }
                            }
                        },
                        grid: {
                            x: 40,
                            y: 40,
                            x2: 45,
                            y2: 60,
                        },
                        dataZoom: [
                            //加上dataZoom可实现缩放
                            {
                                type: 'inside',//x轴
                                xAxisIndex: 0,
                                
                            },
                            {
                                show:true,
                                type: 'slider',//x轴
                                xAxisIndex: 0,
                                zoomOnMouseWheel:'true',//如何触发缩放。可选值为：true：表示不按任何功能键，鼠标滚轮能触发缩放。false：表示鼠标滚轮不能触发缩放。'shift'：表示按住 shift 和鼠标滚轮能触发缩放。'ctrl'：表示按住 ctrl 和鼠标滚轮能触发缩放。'alt'：表示按住 alt 和鼠标滚轮能触发缩放。
                            },
                        ],
                        xAxis: {
                            name:'日期',
                            type: 'category',
                            data: res.xaxis,
                            axisLine: {
                                lineStyle: {
                                color: "#797c85", // 更改 X 轴颜色
                                },
                            },
                        },
                        yAxis: {
                            name: '单量',
                            type: 'value',
                            axisLine: {
                                lineStyle: {
                                color: "#797c85", // 更改 X 轴颜色
                                },
                            },
                        },
                        series: [
                            {
                                data: res.yaxis,
                                type: 'line',
                                smooth: true,
                                areaStyle: { // 区域填充样式。设置后显示成区域面积图。
                                    color: { // 填充的颜色 -- 自定义区域渐变颜色
                                        type: 'linear',
                                        x: 0,
                                        y: 0,
                                        x2: 0,
                                        y2: 1,
                                        colorStops: [
                                            {
                                                offset: 0.5,
                                                color: '#bbd7f9'
                                            },
                                            {
                                                offset: 1,
                                                color: '#486c9c'
                                            }
                                        ]
                                    }
                                },
                                itemStyle: {
                                    color: '#486c9c',
                                },
                            }
                        ]
                    };
                    capacityLine.setOption(option);
                    capacityLine.resize()
                    window.addEventListener('resize', () => {
                        capacityLine.resize()
                    })
                })
                
            },
        },
    }
</script>
<style lang="less" scoped>
.el-input__inner {
    color: #ffffff;
    background-color: #000000 ;
}
:deep(.el-date-editor .el-range-separator){
    color: #ffffff;
}
:deep(.el-date-editor .el-range-input){
    color: #ffffff;
    background-color: #000000 !important;
}
#app{
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%; 
    overflow: hidden;
}
#container{
    width: auto;
    height: 100%;
    background: #000000;
    overflow: hidden;
    position: relative;
    padding: 0 2%;
    color: #ffffff;
}
.page_top{
    height: 13%;
    display: flex; 
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items:center;
}
.top_left{
    display: flex;
    justify-content:flex-start;
    align-items: center;
}
.logo{
    display: flex;
}
.wms_name{
    display: flex;
    position: relative;
    font-size: 34px;
    color: #777985;
    margin-left: 10px;
    margin-right: 45px;
}
.top_time{
    display: flex;
    justify-content:flex-end;
    height: 100%;
    align-items: center;
}
.order_list{
    height: 12.5%;
    display: flex;
    justify-content: space-between;
    align-items:center;
}
.order{
    height: 100%;
    background: #1b1e25;
    display: flex; 
    flex-direction:column;
    padding-top: 5px; 
    justify-content: center;
    align-items: flex-start;
    width:19.2%;
    padding-left: 1.2%;
    box-sizing: border-box;
}
.order_name{
    font-size: 14px;
    color: #989399;
    line-height: 26px;
}
.order_num{
    font-family: "黑体"; 
    height: 100%;
    display: flex;
    justify-content:flex-start;
    align-items:center ;
    font-size: 32px;
    font-weight: 900;
}
.main{
    height: 69%;
    background: #0c111d;
    margin-top: 1%;
    display: flex;
    justify-content:space-between;
    align-items:center;
}
.main_left{
    display: flex; 
    width:48%;
    height: 100%;
    flex-direction: column;
    justify-content:center;
    align-items:center;
}
.main_midd{
    display: flex; 
    width:35%;
    height: 100%;
    flex-direction: column;
    justify-content:space-between;
    align-items:flex-start;
}
.home_today{
    width: 100%;
    height: 49%;
    display: flex;
    background: #1b1e25;
    flex-direction: column;
    justify-content:flex-start;
    align-items:flex-start; 
    margin-bottom: 2%;
    padding-top: 2%;
    box-sizing: border-box;
}
.home_tit{
    flex-grow:0;
    flex-shrink:0;
    display: flex;
    font-size: 14px;
    color: #797c85;
    padding-left: 3%;
    box-sizing: border-box;
}
#home_today{
    width: 100%;
    display: flex;
    height: 100%;
    flex-direction: column;
    justify-content:flex-start;
    align-items:flex-start;
}
.ship_order{
    width: 100%;
    height: 49%;
    display: flex;
    background: #1b1e25;
}
#ship_order{
    padding-top:10px;
    box-sizing: border-box;
}
.imple{
    width: 100%;
    height: 49%;
    padding-right: 20px;
    box-sizing: border-box; 
    display: flex;
    background: #1b1e25;
    flex-direction: column;
    justify-content:flex-start;
    align-items:flex-start; 
    // margin-bottom: 2%;
    padding-top: 2%;
    box-sizing: border-box;
}
.main_rig{
    display: flex;
    background: #1b1e25; 
    width:15%;
    height: 100%;
    flex-direction: column;
    justify-content:flex-start;
    align-items:flex-start;
    padding: 10px;
    box-sizing: border-box;
}
.situ_tit{
    display: flex; 
    font-size: 14px;
    color: #979b9e;
    line-height: 20px;
    padding-top: 5px;
}

</style>